"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useObjectForm = exports.RULES_REQUIRED_BASIC = void 0;
var react_1 = __importStar(require("react"));
var lodash_1 = require("lodash");
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var utils_1 = require("../utils");
exports.RULES_REQUIRED_BASIC = [{ required: true }];
var styles = {
    lastSaved: { color: "#AAA", fontStyle: "italic" },
};
var useObjectForm = function (_a) {
    // Process parameters
    var initialValues = _a.initialValues, transformInitialValues = _a.transformInitialValues, transformFinalValues = _a.transformFinalValues, onFinish = _a.onFinish, onView = _a.onView, localDataKey = _a.localDataKey, loading = _a.loading;
    transformInitialValues = transformInitialValues || utils_1.id;
    transformFinalValues = transformFinalValues || utils_1.id;
    // Set up hooks
    var form = antd_1.Form.useForm()[0];
    var editMode = (0, react_1.useMemo)(function () { return !!Object.keys(initialValues !== null && initialValues !== void 0 ? initialValues : {}).length; }, [initialValues]);
    var _b = (0, react_1.useState)((0, utils_1.getLocalStorageJSON)(localDataKey)), savedData = _b[0], setSavedData = _b[1];
    var _c = (0, react_1.useState)(null), lastSavedTime = _c[0], setLastSavedTime = _c[1];
    var _d = (0, react_1.useState)(null), initialFormRetrievedValues = _d[0], setInitialFormRetrievedValues = _d[1];
    var _e = (0, react_1.useState)(true), isInInitialState = _e[0], setIsInInitialState = _e[1];
    var oldInitialValues = (0, react_1.useMemo)(function () { return initialValues ? __assign(__assign({}, initialValues), savedData) : __assign({}, savedData); }, [initialValues, savedData]);
    var newInitialValues = (0, react_1.useMemo)(function () { return transformInitialValues(oldInitialValues); }, [oldInitialValues]);
    (0, react_1.useEffect)(function () {
        if (!form)
            return;
        form.setFieldsValue(newInitialValues);
        setInitialFormRetrievedValues(transformFinalValues(form.getFieldsValue(true)));
        setIsInInitialState(true);
    }, [form, newInitialValues]);
    var clearLocalData = (0, react_1.useCallback)(function () {
        if (localDataKey) {
            localStorage.removeItem(localDataKey);
        }
    }, [localDataKey]);
    var setLastSavedNow = (0, react_1.useCallback)(function () {
        var date = new Date(Date.now());
        setLastSavedTime("".concat(date.toLocaleDateString(), ", ").concat(date.getHours(), ":").concat(date.getMinutes()));
    }, []);
    // noinspection JSCheckFunctionSignatures
    var processLocalChanges = (0, react_1.useCallback)((0, lodash_1.throttle)(function (providedValues) {
        if (providedValues === void 0) { providedValues = undefined; }
        if (!form)
            return;
        var values = transformFinalValues(providedValues !== null && providedValues !== void 0 ? providedValues : form.getFieldsValue(true));
        setIsInInitialState((0, lodash_1.isEqual)(values, initialFormRetrievedValues));
        if (!localDataKey)
            return;
        var valuesJSON = JSON.stringify(values);
        if (localStorage.getItem(localDataKey) !== valuesJSON) {
            console.log("saving locally", values);
            (0, utils_1.setLocalStorageJSON)(localDataKey, values);
            setLastSavedNow();
        }
    }, 500), [form, localDataKey, initialFormRetrievedValues]);
    (0, react_1.useEffect)(function () {
        // noinspection JSCheckFunctionSignatures
        var interval = setInterval(processLocalChanges, 1000);
        return function () {
            clearInterval(interval);
        };
    }, [processLocalChanges]);
    (0, react_1.useEffect)(function () {
        // Reset fields to initial value if savedData changes
        form.resetFields();
    }, [savedData]);
    // noinspection JSCheckFunctionSignatures
    var onValuesChange = (0, react_1.useCallback)(function (_, allValues) { return processLocalChanges(allValues); }, [processLocalChanges]);
    var onFinish_ = (0, react_1.useCallback)(function (v) {
        var fv = transformFinalValues(__assign(__assign({}, newInitialValues), v));
        (onFinish !== null && onFinish !== void 0 ? onFinish : utils_1.nop)(fv);
        // TODO: Handle saved data here for when edit mode also has it
        clearLocalData();
    }, [transformFinalValues, newInitialValues, onFinish, clearLocalData]);
    var view = (0, react_1.useMemo)(function () { return onView ? function () { return onView(newInitialValues); } : undefined; }, [onView, newInitialValues]);
    var submitAndView = (0, react_1.useCallback)(function () {
        onFinish_(form.getFieldsValue(true));
        if (view)
            view();
    }, [form, view]);
    var resetChanges = (0, react_1.useCallback)(function () {
        setSavedData({});
        clearLocalData();
        setLastSavedNow();
    }, [clearLocalData]);
    return {
        clearLocalData: clearLocalData,
        processLocalChanges: processLocalChanges,
        localDataKey: localDataKey,
        onFinish_: onFinish_,
        onValuesChange: onValuesChange,
        resetChanges: resetChanges,
        submitAndView: submitAndView,
        view: view,
        form: form,
        editMode: editMode,
        isInInitialState: isInInitialState,
        loading: loading !== null && loading !== void 0 ? loading : false,
        lastSavedTime: lastSavedTime,
        transformedInitialValues: newInitialValues,
    };
};
exports.useObjectForm = useObjectForm;
var ObjectForm = react_1.default.memo(function (_a) {
    var initialValues = _a.initialValues, loading = _a.loading, objectForm = _a.objectForm, onCancel = _a.onCancel, children = _a.children, props = __rest(_a, ["initialValues", "loading", "objectForm", "onCancel", "children"]);
    var form = objectForm.form, editMode = objectForm.editMode, isInInitialState = objectForm.isInInitialState, lastSavedTime = objectForm.lastSavedTime, localDataKey = objectForm.localDataKey, transformedInitialValues = objectForm.transformedInitialValues, onFinish_ = objectForm.onFinish_, onValuesChange = objectForm.onValuesChange, resetChanges = objectForm.resetChanges, submitAndView = objectForm.submitAndView, view = objectForm.view;
    return react_1.default.createElement(antd_1.Form, __assign({}, props, { onFinish: onFinish_, form: form, layout: "vertical", initialValues: transformedInitialValues, onValuesChange: onValuesChange }),
        children,
        react_1.default.createElement(antd_1.Form.Item, null,
            react_1.default.createElement(antd_1.Space, null,
                react_1.default.createElement(antd_1.Button, { type: "primary", htmlType: "submit", disabled: editMode && isInInitialState, loading: loading, icon: react_1.default.createElement(icons_1.SaveOutlined, null) }, editMode ? "Save" : "Submit"),
                view && editMode && (isInInitialState ? (react_1.default.createElement(antd_1.Button, { onClick: view, icon: react_1.default.createElement(icons_1.EyeOutlined, null) }, "View")) : (react_1.default.createElement(antd_1.Button, { onClick: submitAndView, icon: react_1.default.createElement(icons_1.CheckOutlined, null) }, "Save and View"))),
                react_1.default.createElement(antd_1.Button, { disabled: editMode && isInInitialState, onClick: resetChanges }, "Reset Changes"),
                onCancel && (react_1.default.createElement(antd_1.Button, { htmlType: "button", disabled: !isInInitialState, onClick: onCancel }, "Cancel")),
                (localDataKey && lastSavedTime) ? (react_1.default.createElement("span", { style: styles.lastSaved },
                    "Changes last saved locally at ",
                    lastSavedTime,
                    ".")) : null)));
});
exports.default = ObjectForm;
